<script>
import { onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useModalStore } from "@/stores/modal.js";
import { useAuthenticationStore } from "@/stores/authentication.js";

export default {
  setup() {
    // Stores
    const modalStore = useModalStore();
    const authenticationStore = useAuthenticationStore();

    // I18n
    const { t } = useI18n();

    onMounted(async () => { 
      resendVerification();
    });

    const resendVerification = async () => {
      console.debug(`Sending another verification email to: ${modalStore.userEmail}`)

      try {
        const response = await fetch(
          `${import.meta.env.VITE_BACKEND_URL}/api/v2/servicechek/users/resend_verification_email`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              email: modalStore.userEmail,
              password: modalStore.userVerificationPassword,
            }),
          }
        );
      } catch (error) {
        console.error("Error creating user:", error);
      }
    };

    return {
      t,
      modalStore,
      resendVerification,

    }
  },
};
</script>

<template>
</template>

<style lang="scss" scoped>
@import '@/assets/styles/components/modals/resend_verification';
</style>